<template>
  <div>
    <payment-form
      payment-list="/api/payment/list"
      @close="$router.push('/client/payment/list')"
      @list="$router.push('/client/payment/list')"
      @change="id=> $router.push('/client/payment/change?id=' + id)"
      @view="id=> $router.push('/client/payment/view?id=' + id)"
    />
  </div>
</template>

<script>
  export default {
    props: ['create', 'change', 'view'],
    data: () => ({

    }),
    computed: {

    },
    watch: {

    },
    methods: {

    },
  }
</script>
